import { createBusinessAuditLog } from "../sdk/auth/auth";

// utils/logoutUser.js
export const logoutUser = (auth, setAuth) => {
  createBusinessAuditLog({
    category: "Authentication",
    actionCode: "LOGOUT",
    description: "User logged out of the system",
    username: auth?.user?.username,
    page: "Logout",
    tab: "Authentication",
    section: "Logout",
    targetUserId: auth?.user?.id,
  });

  setTimeout(() => {
    const deviceId = localStorage.getItem("rehema_device_id");

    // ✅ Clear EVERYTHING
    localStorage?.clear();
    sessionStorage?.clear();

    // ✅ Restore allowed keys
    if (deviceId) {
      localStorage?.setItem("rehema_device_id", deviceId);
    }

    // ✅ Mark next session as fresh (IMPORTANT for filters)
    sessionStorage?.setItem("isFreshLogin", "true");

    // ✅ Clear auth
    setAuth({});

    // ✅ HARD reload (kills React state + cache)
    window.location.href = "/";
  }, 300);
};

// utils/initSession.js
export const initSession = () => {
  const hasActiveSession = sessionStorage.getItem("app_active_session");

  if (!hasActiveSession) {
    // 🚨 Tab was closed or app reopened → CLEAN STALE DATA
    const deviceId = localStorage.getItem("rehema_device_id");

    localStorage.clear();

    if (deviceId) {
      localStorage.setItem("rehema_device_id", deviceId);
    }
  }

  // ✅ Mark session as active
  sessionStorage.setItem("app_active_session", "true");
};
